$('.item_slide').slick({
    autoplay: true, //自動再生
    infinite: true, //スライドのループ有効化
	draggable: true,
	arrows: true,
    slidesToShow: 5, //表示するスライドの数
    slidesToScroll: 2, //スクロールで切り替わるスライドの数
    responsive: [{
      breakpoint: 768, //ブレークポイントが768px
      settings: {
        slidesToShow: 1.5, //表示するスライドの数
        slidesToScroll: 1, //スクロールで切り替わるスライドの数
      }
    }]
  });